module.exports = __webpack_public_path__ + "static/scale-model-of-andrews-arboretum-in-boulder-colorado-64dc928b9540e310a7c35b5ecaa7d3b1.png";